import { render, staticRenderFns } from "./PxFilterList.vue?vue&type=template&id=1a9e4aca&scoped=true&"
import script from "./PxFilterList.vue?vue&type=script&lang=js&"
export * from "./PxFilterList.vue?vue&type=script&lang=js&"
import style0 from "./PxFilterList.vue?vue&type=style&index=0&id=1a9e4aca&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e4aca",
  null
  
)

export default component.exports